import { render, staticRenderFns } from "./vehiculosAdd.vue?vue&type=template&id=4812757e"
import script from "./vehiculosAdd.vue?vue&type=script&lang=js"
export * from "./vehiculosAdd.vue?vue&type=script&lang=js"
import style0 from "./vehiculosAdd.vue?vue&type=style&index=0&id=4812757e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports